<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('table_label_expense_item') || '费用填报明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
          size="mini"
        />
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderSelect from '@/views/digital/components/order-select'
import tableColumns from './table-columns'
import { add, multiplyRound, format } from '@/libs/util.number.js'
export default {
  components: { OrderSelect },
  props: {
    disabled: { type: Boolean, default: false },
    materialAbnormalCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    custName: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      validRules: {
        costAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_cost_amount_greater_than_0') || '成本费用须大于0',
          },
        ],
        sourceBillNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        materialNcNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        materialName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        materialSpec: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        materialColor: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        materialUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.materialAbnormalCode) return
      this.$api
        .materialAbnormalItemListApi({
          materialAbnormalCode: this.materialAbnormalCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      if (!this.custCode) {
        this.$message.warning('请选择订单客户')
        return
      }
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        {
          custCode: this.custCode,
          custName: this.custName,
        },
        -1,
      )
      await $itemTable.setActiveCell(newRow, 'sourceBillNo')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount({})
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount({})
    },
    async subTotAmount({ row = {} }) {
      if (row != {}) {
        row.costAmount = multiplyRound(row.qty, row.unitPrice, 2)
        row.subAmount = add(row.costAmount, row.otherAmount)
      }

      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.subAmount),
        0,
      )
      this.$emit('updateTotAmount', totAmount)
    },
  },
}
</script>
